const CHECK_SETTINGS_INTERVAL = 1 * 60 * 1000;
const CHECK_TRANSLATION_INTERVAL = 3 * 60 * 1000;

export { CHECK_SETTINGS_INTERVAL, CHECK_TRANSLATION_INTERVAL };
